<script>
  import { useForm, page, router } from '@inertiajs/svelte';
  import FormField from '../form/Field.svelte';
  import FormTextarea from '../form/Textarea.svelte';

  $: contacts = $page.props.contacts;
  $: pagei18n = $page.props.i18n.page;

  const form = useForm({
    first_name: '',
    last_name: '',
    email: '',
    phone: '+371 ',
    budget: '5,000 - 10,000 €',
    date: '',
    message: '',
  });

  function handleSubmit() {
    $form.clearErrors();

    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute($page.props.recaptcka_key, { action: 'submit' })
        .then(function (token) {
          sendForm(token);
        });
    });
  }

  /**
   * Send form data to server
   * @param token
   */
  function sendForm(token) {
    const url = $page.props.ajax_url + '/caballero/contacts';

    $form
      .transform((data) => ({
        ...data,
        token: token,
      }))
      .post(url, {
        preserveScroll: true,
        onSuccess: () => {
          if ($page.props.success_url) {
            router.visit($page.props.success_url);
          } else {
            $form.reset();
          }
        },
      });
  }
</script>

<form class="form" on:submit|preventDefault={handleSubmit}>
  <div class="flexbox flexbox--grid">
    <div class="col col-50 col-s-full">
      <FormField
        label={pagei18n.first_name.label}
        icon="personalcard"
        placeholder={pagei18n.first_name.placeholder}
        error={$form.errors.first_name}
        bind:value={$form.first_name}
      />
    </div>
    <div class="col col-50 col-s-full">
      <FormField
        label={pagei18n.last_name.label}
        icon="personalcard"
        placeholder={pagei18n.last_name.placeholder}
        error={$form.errors.last_name}
        bind:value={$form.last_name}
      />
    </div>
    <div class="col col-50 col-s-full">
      <FormField
        label={pagei18n.email.label}
        icon="sms"
        placeholder={pagei18n.email.placeholder}
        error={$form.errors.email}
        bind:value={$form.email}
      />
    </div>
    <div class="col col-50 col-s-full">
      <FormField
        label={pagei18n.phone}
        icon="call5"
        error={$form.errors.phone}
        bind:value={$form.phone}
      />
    </div>
    <div class="col col-50 col-s-full">
      <FormField
        type="select"
        label={pagei18n.budget}
        icon="arrow-down-1"
        options={contacts.budget_options}
        error={$form.errors.budget}
        bind:value={$form.budget}
      />
    </div>
    <div class="col col-50 col-s-full">
      <FormField
        label={pagei18n.date.label}
        icon="calendar"
        placeholder={pagei18n.date.placeholder}
        error={$form.errors.date}
        bind:value={$form.date}
      />
    </div>
    <div class="col col-full">
      <FormTextarea
        placeholder={pagei18n.message}
        error={$form.errors.message}
        bind:value={$form.message}
      />
    </div>
    {#if $form.errors.error}
      <div class="col col-full text-center">
        <p class="form-error">{$form.errors.error}</p>
      </div>
    {/if}
    <div class="col col-full text-center">
      <div class="g-recaptcha" data-sitekey="your_site_key" />

      <button
        class="btn btn-icon btn-main btn-main--light"
        disabled={$form.processing}
      >
        <i class="isax isax-arrow-right-3" />
        {pagei18n.submit}</button
      >
    </div>
  </div>
</form>

<style lang="scss">
  .form {
    margin: 7rem 0 0;
  }

  .form-error {
    color: var(--red);
  }
</style>
